import React, { useEffect, useState } from 'react';

import './AudioMedia.scss';

const AudioPreview = ({
  className = '',
  file,
  label = '音频预览',
  src,
}) => {
  const [objectUrl, setObjectUrl] = useState('');

  useEffect(() => {
    if (!file) {
      setObjectUrl('');
      return undefined;
    }

    const nextObjectUrl = URL.createObjectURL(file);
    setObjectUrl(nextObjectUrl);
    return () => URL.revokeObjectURL(nextObjectUrl);
  }, [file]);

  const audioSource = file ? objectUrl : src;
  if (!audioSource) return null;

  return (
    <audio
      key={audioSource}
      className={`audio-media-preview ${className}`.trim()}
      aria-label={label}
      controls
      preload="metadata"
      src={audioSource}
    >
      您的浏览器不支持音频播放。
    </audio>
  );
};

export default AudioPreview;
